import React from 'react';
import { Link, graphql, StaticQuery } from "gatsby";
import * as Icon from 'react-feather';

const currentYear = new Date().getFullYear();
// const GET_BLOG_CATEGORIES = graphql`
// query GetBlogCategories {
//     allStrapiBlogCategories {
//       nodes {
//         category_slug
//         category_name
//       }
//     }
//   }

// `
const Footer = () => (
    <footer className="footer-area bg-f7fafd">
            <div className="container-fluid padd-3">
                <div className="row justify-content-center">
                    {/* <div className="col-lg-3 col-sm-6">
                        <div className="single-footer-widget">
                            <div className="logo">
                                <Link to="/it-startup">
                                   
                                </Link>
                            </div>
                            <p>Browse your Flutter Business app at GetWidget Flutter Market Place.</p>
                        </div>
                    </div> */}
                    <div className="col-lg-3 col-sm-6 col-6">
                        <div className="single-footer-widget pl-5">
                            <h3>Site Map</h3>
                            <ul className="list">
                                <li>
                                    <Link to="/">
                                        Home
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" href="https://www.ionicfirebaseapp.com/products">
                                        Products
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" href="https://www.ionicfirebaseapp.com/technologies">
                                        Technologies
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/">
                                        Blogs
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" href="https://www.ionicfirebaseapp.com/contact">
                                        Contact
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-6">
                        <div className="single-footer-widget pl-5">
                        {/* <h3> <br> </br></h3> */}
                        <br></br>
                        <br></br>
                            <ul className="list pt-2">
                                <li>
                                    <Link to="" href="https://www.ionicfirebaseapp.com/extra-services">
                                        Extra Services
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" href="https://www.ionicfirebaseapp.com/affiliate">
                                        Affiliates
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/">
                                        Scholarship
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" href="https://www.ionicfirebaseapp.com/coupons">
                                        Coupon
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" href="https://www.ionicfirebaseapp.com/category/grocery-app">
                                        Category
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6">
                        <div className="single-footer-widget pl-5">
                            <h3>Useful Links</h3>
                            <ul className="list">
                                {/* <li>
                                    <Link to="/about-us/">
                                        Contact
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/contact/">
                                        Blogs
                                    </Link>
                                </li> */}
                                <li>
                                    <Link to='' href="https://docs.ionicfirebaseapp.com/faq" target="_blank">
                                        FAQ
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" href=" https://support.ionicfirebaseapp.com/" target="_blank">
                                        Support
                                    </Link>
                                </li>
                                <li>
                                    <Link to=""  href="https://docs.ionicfirebaseapp.com/faq/licences"
              target="_blank">
                                        License
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" href="https://www.ionicfirebaseapp.com/services">
                                        Services
                                    </Link>
                                </li>
                                <li>
                                <Link to="" href="https://www.ionicfirebaseapp.com/policy">
                                        Privacy Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link to="" href="https://www.ionicfirebaseapp.com/terms">
                                        Terms of use
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* <div className="col-lg-3 col-sm-6">
                        <div className="single-footer-widget">
                            <h3>Tags</h3>
                            <ul className="list">
                                {categoryData.allStrapiBlogCategories.nodes.map((category, c) => (
                                    <li key={c}>
                                        <Link to={`/blogs/tag/${category.category_slug}/`}>
                                            {category.category_name}
                                        </Link>
                                    </li>
                                ))}

                            </ul>
                        </div>
                    </div> */}

                    <div className="col-lg-3 col-sm-6">
                        <div className="single-footer-widget">
                            <div className="free-trial-content">

                                <h3>Contact</h3>
                                {/* <form className="newsletter-form">
                                    <input type="email" className="input-newsletter" placeholder="Enter your email here" />
                                    <button type="submit"><Icon.ArrowRight /></button>
                                </form> */}
                            </div>
                            {/* <h3>Address</h3> */}

                            <ul className="footer-contact-info">
                            <li>
                                    <Icon.Mail className='pt-2'/>
                                    Email: <Link to="" href="mailto:sales@ionicfirebaseapp.com">sales@ionicfirebaseapp.com</Link>
                                </li>
                                <li>
                                    <Icon.MapPin className='pt-2' />
                                    1318, 5th Floor, Jp Nagar Phase 2 Bangalore 560078
                                </li>

                                {/* <li>
                                    <Icon.PhoneCall />
                                    Phone: <Link to="tel:321984754">+ (321) 984 754</Link>
                                </li> */}
                            </ul>
                            <br></br>

                            <ul className="social-links">
                                <li>
                                    <a href="https://www.facebook.com/ionicfirebaseapp" className="facebook" target="_blank" rel="noreferrer"><Icon.Facebook /></a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/ionicfirebaseap" className="twitter" target="_blank" rel="noreferrer"><Icon.Twitter /></a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/ionicfirebaseapps/" className="instagram" target="_blank" rel="noreferrer"><Icon.Instagram /></a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/company/ionicfirebaseapp/" className="linkedin" target="_blank" rel="noreferrer"><Icon.Linkedin /></a>
                                </li>
                            </ul>
                        </div>
                    </div>


                </div>
                <div className="row">
                    <div className="col-lg-12 col-md-12">
                        <div className="copyright-area">
                            <p>Copyright &copy; {currentYear} All rights reserved by <a href="https://www.ionicfirebaseapp.com/" target="_blank">IonicFireBaseApp</a></p>
                        </div>
                    </div>
                    {/* <div className="col-lg-8 col-md-8">
                      <div className='row'>
                        <div className='col-md-4'>
                        <Link to="/terms-conditions/">
                                        Privacy Policy
                                    </Link>
                        </div>
                        <div className='col-md-4'>
                        <Link to="/terms-conditions/">
                                        Terms Of Use
                                    </Link>
                        </div>
                        <div className='col-md-4'>
                        <Link to="/terms-conditions/">
                                        License
                                    </Link>
                        </div>
                      </div>
                    </div> */}
                </div>
            </div>

            {/* <img src="https://ik.imagekit.io/ionicfirebaseapp/getwidget/gatsby-marketplace/map_73hEIgHnG5R.png" loading="lazy" className="map" alt="map" /> */}

            {/* Shape Images */}
            {/* <div className="shape1">
                    <img src={Shape1} alt="shape" />
                </div>
                <div className="shape8 rotateme">
                    <img src={Shape2} alt="shape" />
                </div> */}
        </footer>
)

export default Footer;
